import { Controller } from "@hotwired/stimulus"
import { Collapse } from "../bootstrap_runtime"

// Open the article navigation above its layout breakpoint. Bootstrap 6 also
// collapses block-size, so a responsive display utility alone cannot reveal it.
export default class extends Controller {
  static values = { breakpoint: { type: Number, default: 1200 } }

  connect() {
    this.collapse = Collapse.getOrCreateInstance(this.element, { toggle: false })
    this.media = window.matchMedia(`(min-width: ${this.breakpointValue}px)`)
    this.update = () => this.media.matches ? this.collapse.show() : this.collapse.hide()
    this.media.addEventListener("change", this.update)
    this.update()
  }

  disconnect() {
    this.media.removeEventListener("change", this.update)
    this.collapse.dispose()
  }
}
